/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import clsx from 'clsx';
import React from 'react';
import { tooltipDefaults, TooltipProps } from './Tooltip.props';

/**
 * SDS Tooltip component.
 */
export const Tooltip = (props: TooltipProps): JSX.Element => {
  const { children, classes, label, position, ...rest } = {
    ...tooltipDefaults,
    ...props,
  };

  const tooltipClass = clsx(`sds-tooltip`, `position--${position}`, classes);

  return (
    <div className="sds-tooltip__wrapper" {...rest}>
      <div className={tooltipClass}>
        <span className="sds-tooltip__label">{label}</span>
      </div>
      {children}
    </div>
  );
};
